import React from 'react';
import { connect } from 'react-redux';
import { DBSpecDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestHearingLossRineetest extends React.Component {

    render() {

        return(
            <div key={this.props.panelId} className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Hearing Loss - Rinee Test'/>
                <span className={styles.spacer} />
                <label className={styles.label}>Rinee Test</label>
                <DBSpecDropDownObjective
                    field='TSHEARRINEER'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.r}
                    optionsValue={4}
                />
                <span className={styles.c} />
                <DBSpecDropDownObjective
                    field='TSHEARRINEEL'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.l}
                    optionsValue={4}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHEARRINEER === 'abnormal' ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSHEARRINEEL === 'abnormal'
            ? true : false,
    };
}

const connectedSpecialTestHearingLossRineetest = connect(mapStateToProps)(SpecialTestHearingLossRineetest);
export { connectedSpecialTestHearingLossRineetest as SpecialTestHearingLossRineetest };



